import { Icon, IconProps, Image } from "@chakra-ui/react";

import { BodyText } from "./body-text";

import { formatNumberToLocale } from "@/utils";
import bronzePathSvg from "/assets/leaderboard/bronze.svg";
import goldPathSvg from "/assets/leaderboard/gold.svg";
import silverPathSvg from "/assets/leaderboard/silver.svg";

export const Rank = ({
  rank,
  iconProps,
}: {
  rank?: number;
  iconProps?: IconProps;
}) => {
  const rankContent = () => {
    if (rank === 1) return <Image src={goldPathSvg} />;
    if (rank === 2) return <Image src={silverPathSvg} />;
    if (rank === 3) return <Image src={bronzePathSvg} />;
    if (rank)
      return <BodyText fontSize="md">{formatNumberToLocale(rank)}</BodyText>;
    return <BodyText fontSize="md">N/A</BodyText>;
  };
  return (
    <Icon
      boxSize={8}
      display="flex"
      justifyContent="center"
      alignItems="center"
      {...(iconProps ?? {})}
    >
      {rankContent()}
    </Icon>
  );
};
